import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL || ""}/api/network`;

export const networkRequest = async (method, path, body, csrf) => {
  const token = localStorage.getItem("token");
  const response = await axios.request({
    method, url: `${base}${path}`, data: body, withCredentials: true,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(csrf ? { "X-Network-CSRF": csrf } : {}),
    },
    timeout: 15000,
  });
  return response.data;
};

export function joinWachen(wachen, catalog) {
  return wachen.map((wache) => {
    const instance = catalog.instances.find((item) => item.payment_wache_id === wache.id);
    const network = catalog.networks.find((item) => item.id === instance?.network_id);
    return { wache, instance, network };
  });
}

export const instanceAvailability = (instance) =>
  instance?.availability === "offline" ? "offline" : "online";

export function networkMembershipLabel(instance, network) {
  if (!instance) return "Netzwerk noch nicht unterstützt";
  const availability = instanceAvailability(instance);
  if (network) return `${network.name} · ${availability === "online" ? "Online" : "Offline"}`;
  return availability === "online" ? "Zuordenbar" : "Offline";
}

export function createOperation(method, path, body, revision, uuid = () => crypto.randomUUID()) {
  return { method, path, body: { ...body, request_id: uuid(), expected_revision: revision } };
}

export const pendingKey = (ownerId) => `network-pending:${ownerId}`;
export const isUncertain = (error) => !error.response || error.response.status >= 500 || error.response.status === 401;
export const networkError = (error) => {
  const detail = error.response?.data?.detail;
  return (typeof detail === "string" ? detail : detail?.message) || "Netzwerkdienst nicht erreichbar. Bitte erneut versuchen.";
};

export function readPending(ownerId) {
  try {
    const value = JSON.parse(sessionStorage.getItem(pendingKey(ownerId)));
    if (value && ["POST", "PUT"].includes(value.method) &&
      /^\/(networks|instances\/[0-9a-f-]+\/membership)$/.test(value.path) &&
      typeof value.body?.request_id === "string" && Number.isInteger(value.body?.expected_revision)) return value;
  } catch { /* Invalid local state cannot become a request. */ }
  return null;
}

export function savePending(ownerId, operation) {
  sessionStorage.setItem(pendingKey(ownerId), JSON.stringify(operation));
}

export function clearPending(ownerId) {
  sessionStorage.removeItem(pendingKey(ownerId));
}
